import { Section, SectionHeading } from "@/components/ui";
import { TEAM } from "@/data/about";

/** Full literals so Tailwind sees them. Photo frames alternate blue and orange. */
const FRAMES = [
  "border-brand-500 bg-brand-100",
  "border-brand-200 bg-brand-50",
];

/** Photo cards with the name on a white label. Every other card drops a little on desktop for rhythm. */
export function TeamSection() {
  return (
    <Section id="team" labelledBy="about-team-title" testId="about-team">
      <div className="relative z-10">
        <SectionHeading id="about-team-title" title={TEAM.title} />
        <ul className="mt-10 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-4 lg:gap-6">
          {TEAM.members.map((member, i) => (
            <li key={member.id} className={i % 2 === 1 ? "lg:mt-10" : ""}>
              <article className="group relative" data-testid={`about-team-${member.id}`}>
                <div
                  className={`relative aspect-[4/5] overflow-hidden rounded-4xl border transition-transform duration-300 ${FRAMES[i % FRAMES.length]}`}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/${member.file}`}
                    alt={`${member.name}, ${member.role}`}
                    width={member.width}
                    height={member.height}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="relative z-10 -mt-8 mx-2 sm:-mt-12 rounded-3xl border border-ink bg-white p-3 shadow-soft sm:mx-3 sm:p-4">
                  <h3 className="font-heading text-base font-bold leading-tight sm:text-xl">{member.name}</h3>
                  <p className="mt-0.5 text-xs font-semibold text-ink/70 sm:text-sm">{member.role}</p>
                </div>
              </article>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}
